/**
 * Cleans and formats a telephone number (see https://ltfstyleguide.lifetime.life/?p=elements-inline-elements).
 * @param		{string}		phoneNumber		The raw phone number to clean and format
 * @param		{string}		format			The format to use:
 *													'display'		"(222) 333-4444" or "1-800-555-6666"							Use for display of phone numbers (automatically uses correct format for standard area codes vs. toll-free numbers)
 *													'telUrl'		"tel:+1-222-333-4444"											Use for the globally-unique tel URL scheme format (https://tools.ietf.org/html/rfc3966#section-8)
 *													'ariaLabel'		"call 2 2 2, 3 3 3, 4 4 4 4" or "call 1, 800, 5 5 5, 6 6 6 6"	Use for aria-label property
 * @return		{string}						The formatted phone number
 */

import Vue from 'vue';
import _ from 'lodash';

Vue.filter('phoneFilter', function(phoneNumber, format) {
	let phoneString = phoneNumber.toString();
	if (!phoneString || phoneString.length < 10) {
		return '';
	}
	let tollFreeAreaCodes = ['800', '888', '877', '866', '855', '844'];
	let ariaLabelString = 'call ';
	let countryCode;
	let segments = phoneString.replace(/\D/g, '').match(/^(\d*)(\d{3})(\d{3})(\d{4})/).splice(1);
	countryCode = segments.shift() || '1';

	if (format === 'telUrl') {
		return 'tel:+1-' + segments.join('-');
	} else if (format === 'ariaLabel') {
		// Include country code for toll-free numbers: "call 1, 8 7 7, 5 8 3, 6 8 1 8" or "call 1, 800, 5 8 3, 6 8 1 8" (no country code for regular numbers: "call 2 2 2, 3 3 3, 4 4 4 4")
		if (tollFreeAreaCodes.indexOf(segments[0]) !== -1) {
			if (segments[0] === '800') {
				// Don't remove spaces from "800" segment (just add it to the string and remove the segment from the array so it doesn't get processed by the split/join below)
				segments.shift();
				ariaLabelString = ariaLabelString + countryCode + ', 800, ';
			} else {
				ariaLabelString = ariaLabelString + countryCode + ', ';
			}
		}
		return ariaLabelString + _.map(segments, function(segment) { return segment.split('').join(' '); }).join(', '); // Separate segment numbers by spaces, and join segments with commas

	} else {
		// format == 'display' (also default if no format is specified)
		if (tollFreeAreaCodes.indexOf(segments[0]) === -1) {
			// No country code and use parenthesis for area code for regular phone numbers
			return '(' + segments.shift() + ') ' + segments.join('-');
		} else {
			// Use dash format for toll-free numbers (area codes 800, 888, 877, 866, 855 and 844)
			return countryCode + '-' + segments.join('-');
		}
	}
});
